import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { LearningStudioState } from './types'

const INITIAL_STATE: LearningStudioState = {
  categoriesStatus: 'initial',
  categoryStatus: 'initial',
  articleStatus: 'initial'
}

export const slice = createSlice({
  name: 'studio',
  initialState: INITIAL_STATE,

  reducers: {
    fetchCategories: state => {
      state.categoriesStatus = 'pending'
    },
    fetchCategory: state => {
      state.categoryStatus = 'pending'
    },
    fetchArticle: state => {
      state.articleStatus = 'pending'
    },
    errorFetchCategories: (state, action: PayloadAction<LearningStudioState['error']>) => {
      state.categoriesStatus = 'failure'
      state.error = action.payload
    },
    errorFetchCategory: (state, action: PayloadAction<LearningStudioState['error']>) => {
      state.categoryStatus = 'failure'
      state.error = action.payload
    },
    errorFetchArticle: (state, action: PayloadAction<LearningStudioState['error']>) => {
      state.articleStatus = 'failure'
      state.error = action.payload
    },
    successFetchCategories: (state, action: PayloadAction<LearningStudioState['categories']>) => {
      state.categoriesStatus = 'success'
      state.categories = action.payload
    },
    successFetchCategory: (state, action: PayloadAction<LearningStudioState['selectedCategory']>) => {
      state.categoryStatus = 'success'
      state.selectedCategory = action.payload
    },
    successFetchArticle: (state, action: PayloadAction<LearningStudioState['selectedArticle']>) => {
      state.articleStatus = 'success'
      state.selectedArticle = action.payload
    },
    resetFetchStatus: state => {
      state.categoriesStatus = INITIAL_STATE.categoriesStatus
      state.categoryStatus = INITIAL_STATE.categoryStatus
      state.articleStatus = INITIAL_STATE.articleStatus
    }
  }
})

export const { actions } = slice

export const learningStudioReducer = slice.reducer
